import { PrivilegesEventsCb, SignalRService, TApartmentAsset, TApartmentAssets } from '@simOn/utils/signalR';
import { Subject, firstValueFrom, takeUntil } from 'rxjs';

export function assetEventListener(signalR: SignalRService, payloadFn: Partial<PrivilegesEventsCb>) {
  const destroy = new Subject<void>();

  signalR
    .listenOnEvent<TApartmentAsset>('AssetCreated')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, assetId }) => {
      payloadFn.AssetCreated!({ apartmentId, assetId });
    });

  signalR
    .listenOnEvent<TApartmentAssets>('AssetsCreated')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, assetIds }) => {
      payloadFn.AssetsCreated!({ apartmentId, assetIds });
    });

  signalR
    .listenOnEvent<TApartmentAsset>('AssetModified')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, assetId }) => {
      payloadFn.AssetModified!({ apartmentId, assetId });
    });

  signalR
    .listenOnEvent<TApartmentAssets>('AssetsModified')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, assetIds }) => {
      payloadFn.AssetsModified?.({ apartmentId, assetIds });
    });

  signalR
    .listenOnEvent<TApartmentAssets>('AssetsDeleted')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, assetIds }) => {
      payloadFn.AssetsDeleted!({ apartmentId, assetIds });
    });

  firstValueFrom(signalR.startConnection().pipe(takeUntil(destroy)));
}
